var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('half-circle-spinner',{attrs:{"animation-duration":1000,"size":60,"color":"#1DA643"}})}
var staticRenderFns = []

export { render, staticRenderFns }